"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvPartnerChannelReferenceSchema = void 0;
exports.TvPartnerChannelReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/tv-partner-channels.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TvPartnerChannelReference",
    "description": "A partner channel lives within the TV space and will allow users to see everything related to a given partner programming (e.g. Padel, WSL).",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:tv-partner-channels"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHYtcGFydG5lci1jaGFubmVscy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvY29udGVudC90di1wYXJ0bmVyLWNoYW5uZWxzLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLEtBQUssRUFBRSxtRkFBbUY7SUFDMUYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsMkJBQTJCO0lBQ3BDLGFBQWEsRUFBRSw4SUFBOEk7SUFDN0osTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTixnQ0FBZ0M7YUFDakM7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSw2RUFBNkU7U0FDekY7S0FDRjtDQUNGLENBQUEifQ==